class Player {
    linesScheme = [
        trans("GK"), //0
        trans("DEF"), //1
        trans("MF"), //2
        trans("ST"), //3
    ];
    // linesFullScheme = [
    //     "Goalkeeper",  //0
    //     "Defender", //1
    //     "Midfielder", //2
    //     "Attacker"  //3
    // ]
    constructor(position, positionName, line, lineSize, Game) {
        this.anonymous = "/images/player.svg";
        this.image = "/images/player.svg";
        this.id = -1;
        this.players = Game.players;
        this.baseGame = Game;
        this.position = position;
        this.positionName = positionName;
        this.line = line;
        this.lineSize = lineSize;
    }

    setPlayers(playersData) {
        this.players = playersData;
    }

    handleClick(event) {
        event.preventDefault();
        if (event.target.className.includes("dropdown-item")) {
            // check if current player is set it already
            if (this.id !== -1) {
                $(`.uuid-${this.id}`).css("display", "block");
            }

            this.setPlayer(event.target.getAttribute("data-value"));
        }
    }

    handleReset(event) {
        event.stopPropagation();
        if (this.id !== -1) {
            $(`.uuid-${this.id}`).css("display", "block");
            this.id = -1;

            //get the current player and update the image and name
            const playerElementClass = "line-" + this.line + "-player-" + this.position;
            const playerElement = this.baseGame.baseGameElement.getElementsByClassName(playerElementClass)[0];
            playerElement.getElementsByTagName("img")[0].src = this.anonymous;

            const addButton = playerElement.getElementsByClassName("add-player-button")[0];
            // add =  Voeg toe
            addButton.innerHTML = `<span><i class="fa fa-plus" aria-hidden="true"></i></span> ${
                this.linesScheme[this.line]
            }`;
        }
    }

    setPlayer(id, meta = {}) {
        if (this.players) {
            const player = this.players.filter((player) => player.sportMonksId == id);
            if (player.length) {
                //you can not set player in uncorrect place or postion
                // if(player[0].position != this.linesFullScheme[this.line]){
                //     return;
                // }
                this.image = player[0].imagePath;
                this.id = player[0].sportMonksId;
                this.name = player[0].lastName;
                //get the current player and update the image and name
                const playerElementClass = "line-" + this.line + "-player-" + this.position;
                const playerElement = this.baseGame.baseGameElement.getElementsByClassName(playerElementClass)[0];
                playerElement.getElementsByTagName("img")[0].src = this.image;

                const addButton = playerElement.getElementsByClassName("add-player-button")[0];
                if (this.baseGame.options.interactive) {
                    addButton.innerHTML = "";
                    addButton.append(this.getResetButton());
                    addButton.append(this.name);
                } else {
                    addButton.innerText = meta.label ? this.name + " (" + meta.label + ")" : this.name;
                    addButton.style = "pointer-events: none;";
                }
                $(`.uuid-${this.id}`).css("display", "none");
            }
        }
    }

    getResetButton() {
        const resetButton = document.createElement("span");
        resetButton.innerHTML = '<i class="fa fa-trash" aria-hidden="true"></i>';
        resetButton.addEventListener("click", this.handleReset.bind(this), true);
        return resetButton;
    }

    getAddButton() {
        const buttonWrapper = document.createElement("div");
        // buttonWrapper.className = "dropright";
        buttonWrapper.style = "top: 35px; position: relative;";
        const addButton = document.createElement("button");
        addButton.setAttribute("data-toggle", "dropdown");
        addButton.setAttribute("aria-haspopup", "true");
        addButton.setAttribute("data-flip", "false");
        addButton.id = "btn-player-" + this.position + "_" + this.line;
        addButton.className = "add-player-button";
        // add =  Voeg toe
        addButton.innerHTML = `${
            this.baseGame.options.interactive ? '<span><i class="fa fa-plus" aria-hidden="true"></i></span> ' : ""
        } ${this.linesScheme[this.line]}`;
        if (this.baseGame.options.interactive) {
            buttonWrapper.innerHTML = `<div class="dropdown-menu bg-light px-2 py-0" id="player-list${this.position}_${
                this.line
            }" aria-labelledby="dropdownMenuButton" style="max-height: 500px;min-width: 12rem;">
                    ${this.getPlyersOptionsList()}
                </div>`;
        }
        buttonWrapper.append(addButton);
        buttonWrapper.addEventListener("click", this.handleClick.bind(this));
        return buttonWrapper;
    }

    getSortedPlayersGroups() {
        switch (this.line) {
            case 0:
                return {
                    Goalkeepers: [],
                    Defenders: [],
                    Midfielders: [],
                    Attackers: [],
                };
                break;
            case 1:
                return {
                    Defenders: [],
                    Goalkeepers: [],
                    Midfielders: [],
                    Attackers: [],
                };
                break;
            case 2:
                return {
                    Midfielders: [],
                    Goalkeepers: [],
                    Defenders: [],
                    Attackers: [],
                };
                break;
            case 3:
                if (this.baseGame.basePlayersLineup.length == 5) {
                    return {
                        Midfielders: [],
                        Goalkeepers: [],
                        Defenders: [],
                        Attackers: [],
                    };
                }
                return {
                    Attackers: [],
                    Goalkeepers: [],
                    Defenders: [],
                    Midfielders: [],
                };
                break;
            default:
                return {
                    Attackers: [],
                    Goalkeepers: [],
                    Defenders: [],
                    Midfielders: [],
                };
        }
    }

    getPlyersOptionsList() {
        if (this.players.length == 0) return "";
        const palyersGroups = this.getSortedPlayersGroups();

        this.players.forEach((player) => {
            switch (player.position) {
                case "Goalkeeper":
                    palyersGroups.Goalkeepers.push(player);
                    break;
                case "Defender":
                    palyersGroups.Defenders.push(player);
                    break;
                case "Midfielder":
                    palyersGroups.Midfielders.push(player);
                    break;
                case "Attacker":
                    palyersGroups.Attackers.push(player);
                    break;
            }
        });
        let plyersListItems = "";

        for (const postion in palyersGroups) {
            const plyersListGroup = palyersGroups[postion].map((player) => {
                return `<button class="dropdown-item bg-white rounded-lg px-1 my-2 overflow-hidden uuid-${player.sportMonksId}" data-value="${player.sportMonksId}" style="line-height: 30px;">
                    <img src="${player.imagePath}" class="float-left mr-2" width="30px" style="pointer-events: none;">
                    ${player.lastName}
                    </button>
                `;
            });
            plyersListItems += ` <div>
                <h6 class="dark-text-white">${trans(postion)}</h6>
                ${plyersListGroup.join("")}
            </div>`;
        }

        return plyersListItems;
    }

    getStyle() {
        // for the midfield (line=2)
        if (this.lineSize === 5 && this.line == 2) {
            if (this.position == 0 || this.position == 4) {
                return "top:-37px";
            } else if (this.position == 2) {
                return "top:-65px";
            } else {
                return "top:55px";
            }
        }
        //first line and (first item and last item in any line)
        else if (this.line === 0 || this.lineSize === this.position + 1 || this.position === 0) {
            return "";
        }

        if (this.lineSize === 6) {
            if (this.position == 2 || this.position == 3) {
                return "top:68px";
            }
            return "top:40px";
        }

        switch (this.line) {
            case 1:
                if (this.lineSize === 3) {
                    return "";
                }
            case 2:
                if (this.lineSize === 5) {
                    if (this.position == 2) {
                        return "top:57px";
                    }
                    return "top:28px";
                }
                return "top:50px";
            case 3:
                if (this.lineSize === 5) {
                    if (this.position == 2) {
                        return "top:-55px";
                    }
                    return "top:-28px";
                }
                return "top:-60px";
            case 4:
                if (this.lineSize === 3) {
                    if (this.position == 1) {
                        return "top:-24px";
                    }
                }
        }
        return ``;
    }

    render() {
        //if there is five lines in the formation
        if (this.baseGame.basePlayersLineup.length == 5) {
            this.linesScheme.splice(2, 0, trans("MF"));
        }

        const player = document.createElement("div");
        player.className = "base-player " + "line-" + this.line + "-player-" + this.position;

        player.style = this.getStyle();
        player.innerHTML = `<img width="40" src="${this.image}">`;

        player.append(this.getAddButton());

        return player;
    }
}

const baseConfig = {
    interactive: true,
};

class LineupGame {
    constructor(id, options = {}) {
        this.options = { ...baseConfig, ...options };
        this.baseGameElement = document.getElementById(id);
        this.players = [];
        this.plans = [];
        this.basePlayersLineup = [];
        this.selectedFormation = 0;
        this.selectedFormationId = null;
        //set pages flags and userId
        this.setEnvVariables();

        // console.info(this);
        //pages [public page, private page ,community page ,article page]
    }

    initialize(callback) {
        if (this.options.interactive) {
            this.loadInitialData().then((data) => {
                this.userMetaData = data[0];
                const upcomingMatch = data[1];
                if (upcomingMatch) {
                    this.match = {
                        id: upcomingMatch.id,
                        awayTeam: upcomingMatch.awayTeam,
                        homeTeam: upcomingMatch.homeTeam,
                    };
                    this.initializeGame(callback);
                } else {
                    //stop game since there is no upcoming match
                    this.baseGameElement.getElementsByClassName("loader")[0].className = "done";
                    return;
                }
            });
        } else {
            this.initializeGame(callback);
        }
    }

    initializeGame(callback = null) {
        if (!this.isPrivateProfilePage && this.isPublicProfilePage && !this.isMyPublicProfilePage) {
            //in public_profile page we can not get userId from localStorage so it is passed from backend
            //render this client line up if this is not my profile page
            //and make the game un-interactive
            this.options.interactive = false;
            //if one user visit someone else public profile
            this.userId = this.baseGameElement.getAttribute("data-user-id");
            this.match = this.baseGameElement.getAttribute("data-match-id");
            if (this.userId == -1) {
                this.baseGameElement.getElementsByClassName("loader")[0].className = "done";
                return;
            }
        } else if (
            !this.isPrivateProfilePage &&
            !this.isPublicProfilePage &&
            this.options.interactive &&
            isAuthenticated() &&
            this.isAlreadyVoted()
        ) {
            // in editor lineup widgets
            this.renderAlreadyVotedWidget();
            return;
        } else if (this.options.interactive && !isAuthenticated()) {
            this.renderUnauthenticatedWidget();
            return;
        }
        //if you in others public profile
        //if you in article page and you authenticated
        //if you in community page

        this.getPlayersData().then((data) => {
            this.players = data;
            this.start();
            this.handleNewLineupPlan();
            if (callback) {
                callback(this);
            } else {
                this.handleCurrentFormation();
            }
        });
    }

    loadInitialData() {
        return Promise.all([this.loadUserMetaData(), this.getUpcomingMatch()]);
    }

    start() {
        this.baseGameElement.getElementsByTagName("img")[0].style.height = "688px";
        this.baseGameElement.getElementsByClassName("loader")[0].className = "done";
        this.renderControlPanel();
    }

    setup() {
        this.lineups = [];
        /* 
             + + +        ST
             + + +        MF
            + + + +       DEF
               +          GK
        */
        for (let index = this.basePlayersLineup.length - 1; index >= 0; index--) {
            this.lineups.push(this.getLineContainer(index));
        }
        this.baseGameElement.getElementsByClassName("lines-container")[0].innerHTML = "";
    }

    getPlayersData() {
        return new Promise(function (resolve, reject) {
            if (window.favorite_team_data && window.favorite_team_data.squad) {
                resolve(window.favorite_team_data.squad);
                return;
            }
            var favorite_team = $("#favorite_team").val();
            var relativeBaseUrl = "/api/v2";
            // var soccerServiceBaseUrl = $("#soccer_service_url").val() + "/api/v1";

            $.ajax({
                async: true,
                type: "GET",
                url: `${relativeBaseUrl}/matchcenter/teams/${favorite_team}`,
                success: function (res) {
                    window.favorite_team_data = res.data;
                    resolve(res.data.squad);
                },
                error: function (error) {
                    console.log(error);
                    reject(error);
                },
            });
        });
    }

    getUpcomingMatch() {
        return new Promise(function (resolve, reject) {
            var favorite_team = $("#favorite_team").val();
            // var relativeBaseUrl = '/api/v2';
            var soccerServiceBaseUrl = $("#soccer_service_url").val() + "/api/v1";

            fetch(`${soccerServiceBaseUrl}/teams/${favorite_team}/fixtures`, {
                method: "GET",
            }).then((response) => {
                response.json().then((res) => {
                    // here the data from the api
                    // console.log(res);
                    let upcomingMatch = null;
                    if (res.data) {
                        for (let index = 0; index < res.data.teamFixtures.length; index++) {
                            const match = res.data.teamFixtures[index];
                            if (match.status == "not_started") {
                                upcomingMatch = match;
                                break;
                            }
                        }
                    }
                    resolve(upcomingMatch);
                });
            });

            // console.log(`has changed`);
            // $.ajax({
            //     type: "GET",
            //     url: `${soccerServiceBaseUrl}/teams/${favorite_team}/fixtures`,
            //     success: function (res) {
            //         let upcomingMatch = null;
            //         if (res.data) {
            //             for (let index = 0; index < res.data.teamFixtures.length; index++) {
            //                 const match = res.data.teamFixtures[index];
            //                 if ((match.status = "not_started")) {
            //                     upcomingMatch = match;
            //                     break;
            //                 }
            //             }
            //         }
            //         resolve(upcomingMatch);
            //     },
            //     error: function (error) {
            //         console.log(error);
            //         reject(error);
            //     },
            // });
        });
    }

    handleNewLineupPlan() {
        // clear old objects
        this.setupBasePlayersLineup();
        this.setup();
        this.render();
    }

    handleSubmit(event) {
        event.preventDefault();
        // this.basePlayersLineup
        if (!this.canSubmit()) {
            this.alert(trans("Please fill all positions"));
        } else {
            this.alert(
                trans("Are you sure you want to use {} as a formation?").replace(
                    "{}",
                    this.plans[this.selectedFormation]["name"]
                ),
                true
            );
        }
    }

    submit(event) {
        const spinner = event.target.getElementsByTagName("span")[0];
        spinner.style.display = "inline-block";
        let result = [];
        this.basePlayersLineup.forEach((playersLine) => {
            playersLine.forEach((player) => {
                result.push({
                    player: player.id,
                    position: player.positionName,
                });
            });
        });

        this.submitFormation(result)
            .then((res) => {
                spinner.style.display = "none";

                // this.setUserMeta(this.selectedFormationId);
                this.alert(trans("Thank you, your formation is set"));
            })
            .catch((error) => {
                spinner.style.display = "none";

                const customErrorsKey = ["api.no_current_fixture"];
                if (
                    error.responseJSON &&
                    typeof error.responseJSON.metaData.key !== "undefined" &&
                    customErrorsKey.includes(error.responseJSON.metaData.key)
                ) {
                    this.alert(error.responseJSON.metaData.message);
                    return;
                }
                this.alert(trans("Sorry ,try again"));
            });
    }

    submitFormation(data) {
        const that = this;
        return new Promise(function (resolve, reject) {
            $.ajax({
                async: true,
                type: "POST",
                headers: getAuthHeader(),
                data: { ...data },
                url: `/api/v2/formations/${that.plans[that.selectedFormation].id}/fixtures`,
                success: function (res) {
                    resolve(res);
                },
                error: function (error) {
                    //console.log(error);
                    reject(error);
                },
            });
        });
    }

    loadUserMetaData() {
        const that = this;
        return new Promise(function (resolve, reject) {
            let tenant = $("#tenant_id").val();
            fetch(`${apiUrl()}/api/v2/user-info/${that.userId}?tenant_id=${tenant}`, {
                method: "GET",
            }).then((response) => {
                response.json().then((data) => {
                    let meta = data.data;
                    let metaValue = {
                        current_formation_id: null,
                        previous_formation_id: null,
                    };
                    if (Array.isArray(meta)) {
                        meta = meta.filter((metaRow) => metaRow.key == "has_formation");
                        if (meta.length && meta[0].value) {
                            metaValue = meta[0].value;
                        }
                    }
                    resolve(metaValue);
                });
            });
        });
    }
    /**
     * @deprecated
     *
     * use the api instead of local storage @loadUserMetaData
     */
    setUserMeta(currentId, previousId = null) {
        let updated = false;
        const user_object = JSON.parse(localStorage.getItem("user_object"));

        if (!Array.isArray(user_object.meta)) {
            user_object.meta = [];
        }
        const newMeta = user_object.meta.map((metaRow) => {
            if (metaRow.key == "has_formation") {
                updated = true;
                metaRow.value = {
                    ...metaRow.value,
                    current_formation_id: currentId,
                };
            }
            return metaRow;
        });
        if (updated === false) {
            user_object.meta.push({
                key: "has_formation",
                value: {
                    current_formation_id: currentId,
                },
            });
        } else {
            user_object.meta = newMeta;
        }
        localStorage.setItem("user_object", JSON.stringify(user_object));
    }

    isAlreadyVoted() {
        //CHECK: maybe we need th compare the current_formation_id with current one
        return Boolean(this.userMetaData.current_formation_id);
    }

    setEnvVariables() {
        //getUserData is global function in auth.js script
        let user = getUserData();

        this.isPrivateProfilePage = location.href.includes("/user/profile");
        this.isPublicProfilePage = location.href.includes("/user/");
        this.isMyPublicProfilePage = false;
        this.userId = -1;
        if (isAuthenticated()) {
            if (user && "username" in user)
                this.isMyPublicProfilePage = location.href.includes("/user/" + user.username);
            if (user && "id" in user) this.userId = user.id;
        }
    }

    canSubmit() {
        if (this.basePlayersLineup.length === 0 || !isAuthenticated()) return false;

        for (let i = 0; i < this.basePlayersLineup.length; i++) {
            const playersLine = this.basePlayersLineup[i];
            for (let j = 0; j < playersLine.length; j++) {
                const player = playersLine[j];
                if (player.id == -1) {
                    return false;
                }
            }
        }

        return true;
    }

    handleCurrentFormation() {
        if (!this.userId) return;

        // we can add here some logic to prevent load this data to make the page lighter
        this.getUserFormationHistory(false)
            .then((data) => {
                if (data && data[0] && data[0].positions.length) {
                    this.setFormation(data[0].formation_id, data[0]);
                } else if (!this.options.interactive) {
                    //hide all game views
                    this.baseGameElement.style.display = "none";
                }
            })
            .catch((err) => {
                console.log(trans("no data in current league for you"));
            });
    }

    handlePreviousFormation(event) {
        event.preventDefault();
        this.getUserFormationHistory(true)
            .then((data) => {
                if (data && data[0] && data[0].positions.length) {
                    this.setFormation(data[0].formation_id, data[0]);
                } else {
                    this.alert(trans("no data saved for you"));
                }
            })
            .catch((err) => {
                this.alert(trans("no data saved for you"));
            });
    }

    handleFormationById(id) {
        this.getFormation(id)
            .then((data) => {
                this.setFormation(id, data);
            })
            .catch((err) => {
                console.log("no data for formation : " + id);
            });
    }

    getPreviousFormationButton() {
        const PreFormationButton = document.createElement("button");
        PreFormationButton.className = "mt-1 btn btn-danger-light text-danger w-100";
        PreFormationButton.style.borderRadius = "8px";
        PreFormationButton.innerHTML = `<i class="fa fa-refresh" aria-hidden="true"></i> 
            Gebruik vorige opstelling
            <span style="display: none;"class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`;
        PreFormationButton.addEventListener("click", this.handlePreviousFormation.bind(this));
        return PreFormationButton;
    }

    getSubmitButton() {
        const submitButton = document.createElement("button");
        submitButton.className = "mt-1 submitButton btn btn-danger-light text-danger w-100";
        submitButton.style.borderRadius = "8px";
        submitButton.style.position = "absolute";
        submitButton.style.bottom = "-45px";
        submitButton.style.left = "0";
        // submitButton.style.display = "none";
        submitButton.innerHTML = `<i class="fa fa-share" aria-hidden="true"></i> ${trans("Save")}`;
        submitButton.addEventListener("click", this.handleSubmit.bind(this));
        return submitButton;
    }

    getFormation(formationId) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                async: false,
                type: "GET",
                url: "/api/v2/user-formations/" + formationId,
                success: function (res) {
                    resolve(res.data);
                },
                error: function (error) {
                    reject(error);
                },
            });
        });
    }

    getUserFormationHistory(previous = true) {
        const that = this;
        return new Promise(function (resolve, reject) {
            var favorite_team = $("#favorite_team").val();
            var soccerServiceBaseUrl = $("#soccer_service_url").val() + "/api/v1";
            var queryString = previous ? "?previous=1" : "";
            $.ajax({
                async: false,
                type: "GET",
                headers: getAuthHeader(),
                url: "/api/v2/user/" + that.userId + "/formation/fixture" + queryString,
                success: function (res) {
                    resolve(res.data);
                },
                error: function (error) {
                    reject(error);
                },
            });
        });
    }

    setupBasePlayersLineup() {
        const rows = [];
        if (!this.plans[this.selectedFormation]) {
            return;
        }
        const formation = this.plans[this.selectedFormation].meta;

        //change dropdown menu label
        $("#plansDropdownMenu").text(this.plans[this.selectedFormation].name);
        this.selectedFormationId = this.plans[this.selectedFormation].id;

        let playerPosition = 0;
        let line = 0;

        for (let formationLine of formation) {
            const row = [];
            const lineSize = formationLine.length;
            playerPosition = 0;

            for (let position of formationLine) {
                row.push(new Player(playerPosition, position, line, lineSize, this));
                playerPosition++;
            }
            line++;
            rows.push(row);
        }

        this.basePlayersLineup = rows.reverse();
    }

    setFormation(formationId, data) {
        const formationIndex = this.plans.findIndex((plan) => plan.id == formationId);
        this.selectedFormation = formationIndex == -1 ? 0 : formationIndex;
        this.handleNewLineupPlan();

        const positions = data.positions;
        if (!positions) return;
        const orderedFormation = this.basePlayersLineup.reverse();
        positions.forEach((item) => {
            const position = item.position == "goal_keeper" ? [0, 0] : item.position.split(",");
            if (position.length == 2) {
                const player = orderedFormation[parseInt(position[0])][parseInt(position[1])];
                const meta = {};
                if (data.total) {
                    meta.label = Math.round(parseFloat((item.stats / data.total) * 100)) + "%";
                }
                player.setPlayer(item.player, meta);
            }
        });
    }

    renderControlPanel() {
        if (this.options.interactive) {
            const teams = "<br>" + this.match.homeTeam + " - " + this.match.awayTeam;
            const baseSubHeading = this.baseGameElement.getAttribute("data-sub-heading");
            const subHeading = baseSubHeading ? baseSubHeading.replace("{}", teams) : baseSubHeading;

            const list = document.createElement("div");
            list.style = "height: 120px; width:100%; position: absolute; top: -132px;";
            list.innerHTML = `
            <div style="display:flex ;justify-content: space-between;">
                <div>
                    <h2 class="mb-2" style="font-weight: bold;">${this.baseGameElement.getAttribute(
                        "data-heading"
                    )}</h2>                
                </div>
                
                <div>
                    <button class="btn btn-outline-dark dropdown-toggle" type="button" id="plansDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        ${trans("Choose Formation")}
                    </button>
                    <div class="dropdown-menu" id="plans-list" aria-labelledby="plansDropdownMenu">
                        <!--empty now-->
                    </div>
                </div>                
                <!-- Modal -->
                <div class="modal fade" id="lineup-formation-modal" tabindex="-1" role="dialog" aria-labelledby="lineup-formation-modal-title" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content bg-white">
                    <div class="modal-header">
                        <h5 class="modal-title" id="lineup-formation-modal-title">${this.baseGameElement.getAttribute(
                            "data-heading"
                        )}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                    
                    </div>
                    <div class="modal-footer">
                        <button type="button" data-dismiss="modal" class="btn btn-primary">${trans("Close")}</button>
                        <button type="button" class="btn btn-danger-light text-danger btn-accept-and-send" style="display:none">
                            ${trans("Yes")}
                            <span style="display: none;" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </button>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <p class="mb-1" style="min-height: 2rem;">${subHeading}</p>
           
            `;

            list.append(this.getPreviousFormationButton());
            this.baseGameElement.append(list);
            this.baseGameElement
                .getElementsByClassName("btn-accept-and-send")[0]
                .addEventListener("click", this.submit.bind(this));
            this.baseGameElement.append(this.getSubmitButton());
        } else {
            const heading = document.createElement("div");
            heading.style = "height: 35px; width:100%; position: absolute; top: -35px;";
            heading.innerHTML = `
            <div>
                <h2 style="font-weight: bold;">${this.baseGameElement.getAttribute("data-heading")}</h2>
            </div>
            `;
            this.baseGameElement.append(heading);
        }
        //may make it async
        this.getPlansListData();
    }

    getPlansListData() {
        const that = this;
        if (window.formations_data) {
            that.plans = window.formations_data;
            that.renderListItems();
            return;
        }
        $.ajax({
            async: false,
            type: "GET",
            url: "/api/v2/formations",
            success: function (res) {
                res.data.forEach((plan) => {
                    plan.name = plan.name.replaceAll("_", "-");
                });
                //caching it
                window.formations_data = res.data;
                that.plans = res.data;
                that.renderListItems();
            },
            error: function (error) {
                console.log(error);
                reject(error);
            },
        });
    }

    renderListItems() {
        if (!this.options.interactive) return;

        const list = document.getElementById("plans-list");
        const planListItems = this.plans.map(
            (paln, index) =>
                `<button class="dropdown-item" data-value="${index}" data-id="${paln.id}">${paln.name}</button>`
        );
        list.innerHTML = planListItems.join("");

        list.addEventListener("click", (event) => {
            if (event.target.className === "dropdown-item") {
                this.selectedFormation = event.target.getAttribute("data-value");
                this.handleNewLineupPlan();

                document.getElementById("plansDropdownMenu").innerHTML = event.target.innerText;
            }
        });
    }

    getLineContainer(number) {
        const line = document.createElement("div");
        line.className = "line-of-players";
        line.id = "line-" + number;
        if (this.basePlayersLineup.length == 4) {
            line.style =
                (number == 0 ? "align-items: end;" : "") +
                "display: flex;  justify-content: space-around;margin-bottom:" +
                (number == 0 ? 10 : number == 1 ? 25 : number == 2 ? 40 : 31) +
                "%";
        } else {
            // 5lines
            line.style =
                (number == 0 ? "align-items: end;" : "") +
                "display: flex;  justify-content: space-around;margin-bottom:" +
                (number == 0 ? 10 : number == 1 ? 25 : number == 2 ? 27 : number == 3 ? 12 : 28) +
                "%";
        }

        return line;
    }

    getCardComponent(heading, action) {
        return `<div class="d-flex align-items-center">
                    <svg class="" width="40" height="40" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.666687" y="0.666666" width="16.6667" height="16.6667" rx="3" fill="#56B694"></rect>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.74799 0.666666H3.66669C2.00983 0.666666 0.666687 2.00981 0.666687 3.66667V14.3333C0.666687 15.9902 2.00983 17.3333 3.66669 17.3333H5.74799H12.2521H14.3334C15.9902 17.3333 17.3334 15.9902 17.3334 14.3333V3.66667C17.3334 2.00981 15.9902 0.666666 14.3334 0.666666H12.2521H5.74799ZM12.1733 16.4187H14.4187C15.5233 16.4187 16.4187 15.5233 16.4187 14.4187V9.20325L11.1202 9.20325C10.8231 10.0893 9.9861 10.7276 9.00002 10.7276C8.01394 10.7276 7.17696 10.0893 6.8798 9.20325H1.58132V14.4187C1.58132 15.5233 2.47675 16.4187 3.58132 16.4187H5.82675C5.8675 16.2369 5.9239 16.0585 5.99553 15.8856C6.15896 15.491 6.39851 15.1325 6.70049 14.8305C7.00247 14.5286 7.36097 14.289 7.75552 14.1256C8.15008 13.9622 8.57296 13.878 9.00002 13.878C9.42708 13.878 9.84997 13.9622 10.2445 14.1256C10.6391 14.289 10.9976 14.5286 11.2996 14.8305C11.6015 15.1325 11.8411 15.491 12.0045 15.8856C12.0761 16.0585 12.1325 16.2369 12.1733 16.4187ZM1.58132 8.28862V3.5813C1.58132 2.47673 2.47675 1.5813 3.58132 1.5813H5.82675C5.8675 1.76309 5.9239 1.94148 5.99553 2.11442C6.15896 2.50897 6.39851 2.86747 6.70049 3.16945C7.00247 3.47143 7.36097 3.71097 7.75552 3.8744C8.15008 4.03784 8.57296 4.12195 9.00002 4.12195C9.42708 4.12195 9.84997 4.03784 10.2445 3.87441C10.6391 3.71097 10.9976 3.47143 11.2996 3.16945C11.6015 2.86747 11.8411 2.50897 12.0045 2.11442C12.0761 1.94148 12.1325 1.76309 12.1733 1.5813H14.4187C15.5233 1.5813 16.4187 2.47673 16.4187 3.5813V8.28862L11.2267 8.28862C11.124 7.14909 10.1663 6.2561 9.00002 6.2561C7.83375 6.2561 6.87605 7.14909 6.77336 8.28862H1.58132ZM7.67888 8.49187C7.67888 9.22151 8.27038 9.81301 9.00002 9.81301C9.72967 9.81301 10.3212 9.22151 10.3212 8.49187C10.3212 7.76223 9.72967 7.17073 9.00002 7.17073C8.27038 7.17073 7.67888 7.76223 7.67888 8.49187ZM11.2265 16.4187C11.2068 16.3569 11.1844 16.2958 11.1595 16.2356C11.042 15.952 10.8699 15.6943 10.6528 15.4773C10.4358 15.2602 10.1781 15.0881 9.8945 14.9706C9.61092 14.8531 9.30697 14.7927 9.00002 14.7927C8.69307 14.7927 8.38912 14.8531 8.10554 14.9706C7.82195 15.0881 7.56428 15.2602 7.34723 15.4773C7.13018 15.6943 6.95801 15.952 6.84055 16.2356C6.81562 16.2958 6.79326 16.3569 6.77351 16.4187H11.2265ZM6.77351 1.5813C6.79326 1.64314 6.81562 1.70423 6.84055 1.7644C6.95801 2.04799 7.13018 2.30566 7.34723 2.52271C7.56428 2.73976 7.82195 2.91193 8.10554 3.02939C8.38912 3.14686 8.69307 3.20732 9.00002 3.20732C9.30697 3.20732 9.61092 3.14686 9.8945 3.02939C10.1781 2.91193 10.4358 2.73976 10.6528 2.52271C10.8699 2.30566 11.042 2.04799 11.1595 1.7644C11.1844 1.70423 11.2068 1.64314 11.2265 1.5813L6.77351 1.5813Z" fill="white"></path>
                    </svg>
                    <h4 class="col text-black">
                        ${heading}
                    </h4>
            </div>
            <button class="btn btn-danger py-2 font-weight-bold mt-3">${action}</button>
        `;
    }

    renderUnauthenticatedWidget() {
        this.baseGameElement.innerHTML = "";
        const wrapper = document.createElement("div");
        wrapper.className = "p-3 mb-3 bg-white rounded-lg card";
        wrapper.style.width = "420px";
        wrapper.innerHTML = this.getCardComponent(
            "Je moet ingelogd zijn om je Favoriete opstelling te stellen",
            "Log In"
        );
        this.baseGameElement.append(wrapper);
        wrapper.addEventListener("click", function () {
            $("#login_menu").trigger("click");
        });
    }

    renderAlreadyVotedWidget() {
        this.baseGameElement.innerHTML = "";
        const wrapper = document.createElement("div");
        wrapper.className = "p-3 mb-3 bg-white rounded-lg card";
        wrapper.style.width = "420px";
        var favorite_team = $("#favorite_team").val();

        wrapper.innerHTML = this.getCardComponent("Je hebt je opstelling al ingesteld", trans("See More Line-Ups"));
        this.baseGameElement.append(wrapper);
        wrapper.addEventListener("click", function () {
            const username = JSON.parse(localStorage.getItem("user_object")).username;
            location.href = "/user/" + username;
        });
    }

    alert(msg, twoOptions = false) {
        var modal = $("#lineup-formation-modal");

        modal.find(".modal-body").text(msg);
        if (twoOptions) {
            modal.find(".btn-primary").text(trans("No"));
            modal.find(".btn-accept-and-send").show();
        } else {
            modal.find(".btn-primary").text(trans("Close"));
            modal.find(".btn-accept-and-send").hide();
        }
        modal.modal("show");
    }

    render() {
        this.baseGameElement.style.marginTop = this.options.interactive ? "115px" : "30px";
        this.baseGameElement.style.marginBottom = this.options.interactive ? "40px" : "0";
        const linesContainerElement = this.baseGameElement.getElementsByClassName("lines-container")[0];
        let line = 0;
        this.basePlayersLineup.forEach((playersLine) => {
            playersLine.forEach((player) => {
                this.lineups[line].append(player.render());
            });
            line++;
        });

        this.lineups.forEach((line) => linesContainerElement.append(line));
    }
}

let lineupGame;
function setUpFormationGame() {
    const initializedFormations = [];
    if ($("#line-up-most-chosen-accordion").length) {
        document.getElementById("line-up-most-chosen-accordion").addEventListener("click", (event) => {
            if (event.target.className.includes("show-lineup-formation")) {
                const baseGameElement = $("#" + event.target.getAttribute("data-base-game-id"));
                const formationId = baseGameElement.attr("data-formation-id");
                if (!initializedFormations.includes(formationId) && baseGameElement.length) {
                    initializedFormations.push(formationId);
                    lineupGame = new LineupGame(event.target.getAttribute("data-base-game-id"), { interactive: false });
                    lineupGame.initialize(function (game) {
                        game.handleFormationById(formationId);
                    });
                }
            }
        });
    }
}

window.setUpFormationGame = setUpFormationGame;
window.addEventListener("load", function () {
    if ($("#lineup-new-game").length) {
        lineupGame = new LineupGame("lineup-new-game").initialize();
    }
});
